/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfCallStatusWebhookOutput } from "../models/AjaxResponseOfCallStatusWebhookOutput";
import type { JambonzWebhookRequest } from "../models/JambonzWebhookRequest";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class JambonzWebhookAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AjaxResponseOfCallStatusWebhookOutput Success
   * @throws ApiError
   */
  public processCallStatusWebhook({
    requestBody,
  }: {
    requestBody?: JambonzWebhookRequest;
  }): CancelablePromise<AjaxResponseOfCallStatusWebhookOutput> {
    return this.httpRequest.request({
      method: "POST",
      url: "/webhook/call-status",
      body: requestBody,
      mediaType: "application/json",
    });
  }
}
